import { store, dispatch } from "global";
import { PLAYER_SET_MUTE } from "global/actions";

export const tryUnmute = () => {
    const muted = store.getState().player.muted;
    if (!muted) return;

    dispatch({ type: PLAYER_SET_MUTE, payload: { mute: false } });
};
